export const chartOptions: any = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'nearest',
    axis: 'x',
    intersect: false,
  },
  scales: {
    xAxis: {
      ticks: {
        // maxTicksLimit: 2,
        maxRotation: 0,
        minRotation: 0,
        callback: function (val: any, index: any, data: any): any {
          const count = data.length;
          if (count <= 7 || index === 0 || index === count - 1) {
            return val;
          }
          if (count <= 14) {
            return index % 2 === 0 ? val : '';
          }
          if (count <= 21) {
            return index % 3 === 0 ? val : '';
          }

          return index % 4 === 0 ? val : '';
        },
      },
      grid: {
        display: false,
      },
      isoWeekday: 1,
      type: 'time',
      time: {
        round: true,
        unit: 'day',
        tooltipFormat: 'd/MM',
        displayFormats: {
          day: 'd/MM',
        },
      },
    },
    currency: {
      display: false,
      type: 'linear',
      axis: 'y',
      title: 'Currency',
      min: 0,
      ticks: {
        maxTicksLimit: 5,
        includeBounds: false,
        callback: (_: number): string => {
          throw new Error(
            'This callback must be rewrite with formatter before render'
          );
        },
      },
    },
    number: {
      display: false,
      type: 'linear',
      axis: 'y',
      min: 0,
      ticks: {
        maxTicksLimit: 5,
        includeBounds: false,
        callback: (_: number): string => {
          throw new Error(
            'This callback must be rewrite with formatter before render'
          );
        },
      },
    },
    percent: {
      display: false,
      type: 'linear',
      axis: 'y',
      min: 0,
      ticks: {
        maxTicksLimit: 5,
        includeBounds: false,
        callback: (_: number): string => {
          throw new Error(
            'This callback must be rewrite with formatter before render'
          );
        },
      },
    },
  },
  plugins: {
    tooltip: {
      callbacks: {
        label: function (_: any) {
          throw new Error(
            'This callback must be rewrite with formatter before render'
          );
        },
      },
    },
    legend: {
      display: false,
    },
  },
};
